import request from '@/api/request.js'

// 新增
export function PaperVSQuestionInsert(data) {
    return request({
        url: '/api/paper/papervsquestioninsert',
        method: 'post',
        data: data
    })
}

// 新增
export function PaperVSQuestionInsertMany(data) {
    return request({
        url: '/api/paper/papervsquestioninsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function PaperVSQuestionDelete(id) {
    return request({
        url: `/api/paper/papervsquestiondelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function PaperVSQuestionUpdate(id, data) {
    return request({
        url: `/api/paper/papervsquestionupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function PaperVSQuestionGetById(id) {
    return request({
        url: `/api/paper/getpapervsquestionbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function PaperVSQuestionGetList(params) {
    return request({
        url: '/api/paper/getpapervsquestionlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function PaperVSQuestionGetPageList(params) {
    return request({
        url: '/api/paper/getpapervsquestionpagelist',
        method: 'get',
        params: params
    })
}